import React from 'react';
import Header from'../components/common/Header';
import Button from'../components/ui/Button';

interface HeroSectionProps {}

const HeroSection = ({}: HeroSectionProps) => {
  const handleScheduleDemo = () => {
    window.open('https://calendly.com/averpact/demo', '_blank')
  }

  return (
    <section id="hero" className="w-full bg-gradient-to-b from-[#141A231e] to-transparent relative overflow-hidden">
      <div className="w-full max-w-[1440px] mx-auto px-3 xs:px-4 sm:px-6 lg:px-8 relative">
        {/* Background Image + overlay */}
        <div className="absolute inset-0 w-full h-full -z-10">
          <img 
            src="/images/img_frame_217.png" 
            alt="Background" 
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#f5f5f7] via-[#e8e8ed] to-white pointer-events-none" />
        </div>
        
        {/* Content Container */}
        <div className="relative z-10 flex flex-col items-center gap-6 xs:gap-8 sm:gap-12 pt-4 xs:pt-6 pb-8 xs:pb-12 sm:pb-16 lg:pb-20">
          {/* Header */}
          <div className="w-full max-w-[980px]">
            <Header />
          </div>

          {/* Spacer removed — title pulled up */}

          {/* Hero Content */}
          <div className="w-full max-w-[914px] flex flex-col items-center gap-4 xs:gap-6 sm:gap-8 px-3 xs:px-4 sm:px-6 lg:px-0">
            <h1 className="text-[36px] xs:text-[44px] sm:text-[56px] md:text-[72px] lg:text-[88px] font-semibold leading-[1.05] text-center text-[#141A23] font-poly tracking-tight">
              AverPact
            </h1>
          </div>
        </div>

        {/* Gradient Overlay at bottom */}
        <div className="absolute bottom-0 left-0 w-full h-24 xs:h-32 sm:h-48 lg:h-64 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
      </div>
    </section>
  )
}

export default HeroSection
